<main>
  <img src="../../../assets/img/home-background.jpeg" />
</main>
